<template>
  <div class="timePlan">
    <div class="timePlanbg">
      <appHeader activeIndex="timePlan" ></appHeader>
      <div class="timePlanContent">
        <!-- 介绍 -->
        <div class="timePlanInfo">
          <div class="timePlanInfo1">
            <img class="timePlanInfo1Img1" src="../../assets/img/Product/timePlan.png"  alt />
            <br><br><br><br><br>
            <!-- <img class="timePlanInfo1Img2"  src="../../assets/img/products/timePlan/timePlanQRcode.png" alt /> -->
            <!-- <div>扫描二维码下载</div>      -->
          </div>
          <div class="timePlanInfo2">
            <div class="productTitle">
              时间规划生之局
            </div>
            <br>
            极简操作高效管理时间打造轻便生活！
            <br><br>
             <el-divider></el-divider>
             <h4>人生最珍贵的是时间，最容易失去的也是时间，如何合理的规划自己的时间，是当下快节奏生活中所需要去执行的，通过本款APP，希望能有效的帮助到你！它包含以下功能：</h4>
             <p>【生之时】输入自己的出生日期，自动为您计算出您在这个世界上存在的时间，精确到年月日、天小时分钟！</p>
             <p>【历史上的今天】为您展现查看手机当天的历史大事件，从有记录开始一直到中国近现代的各种大世界，一目了然！</p>
             <p>【日程安排】把重要的事情，添加到日程记录中吧，设置好时间和提醒方式，记录上您的标签（学习、工作、生活、娱乐等等），添加上备注，设置好背景，一个美美的日程安排上线啦！</p>
             <p>【添加倒计时】为非常期待的事情添加倒计时吧，比如：结婚纪念日、新年、生日等等，让APP提醒您重要时刻的到来！</p>
             <p>【简约不简单】我们每个功能的实现，都包含超美的背景设置功能，以及人性化的日历视图功能，让您的日程安排一目了然，清新自然！
让时间规划生之局陪伴您度过每个重要时刻！</p>
          </div>
          <div style="clear: both;"></div> 
        </div>
        <!-- 第二部分内容 -->
        <el-divider></el-divider>
        <div class="timePlanCarousel">
          <div class="iconLeft" @click="left"><el-button icon="el-icon-arrow-left" circle></el-button></div>
          <div class="iconRight" @click="right"><el-button icon="el-icon-arrow-right" circle></el-button></div>
          <div class="timePlanWrap">
            <div class="timePlanMainImg" :style="{ left: nowLeft + '%' }">
              <img class="timePlanCarouselImg"   src="../../assets/img/products/timePlan/carousel.png" alt />
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <appFooter></appFooter>

  </div>
</template>
 
<script>
import appHeader from "../components/Header";
import appFooter from "../components/Footer";
export default {
  components: {
    appHeader,appFooter
  },
  data() {
    return {
      nowLeft: 0
    };
  },
  mounted() {},
  methods: {
    
      left() {
        
        if(this.nowLeft >= 0){
          return;
        }
        this.nowLeft = this.nowLeft +15
      },

      right() {
        if(this.nowLeft <= -45){
          return;
        }
        this.nowLeft = this.nowLeft -15
      }
  }
};
</script>
<style>
@import "../../assets/css/products/timePlan.css";
</style>
